import { PlayerRole, WeaponRole } from '@/types/weapon'

import type { weaponsEn } from './en.ts'

export const weaponsRu: typeof weaponsEn = {
  names: {
    nameless_sword: 'Безымянный меч',
    nameless_spear: 'Безымянное копьё',
    strategic_sword: 'Стратегический меч',
    heavenquaker_spear: 'Копьё Неботряса',
    thundercry_blade: 'Клинок Громового клича',
    stormbreaker_spear: 'Копьё Бурелома',
    phalanxbane_blade: 'Клинок Сокрушителя фаланги',
    snowparting_blade: 'Клинок Рассекающий снег',
    panacea_fan: 'Веер Панацеи',
    inkwell_fan: 'Веер Чернильницы',
    soulshade_umbrella: 'Зонт Тени души',
    vernal_umbrella: 'Весенний зонт',
    everspring_umbrella: 'Зонт Вечной весны',
    infernal_twinblades: 'Адские парные клинки',
    mortal_rope_dart: 'Смертельный канатный дротик',
    unfettered_rope_dart: 'Вольный канатный дротик',
    skygrasp_rope_dart: 'Небесный канатный дротик',
    heavenwill_gauntlets: 'Наручи Небесной воли',
    skystrike_gauntlets: 'Наручи Небесного удара',
    riven_twinblades: 'Рассекающие парные клинки',
    museflow_waist_drum: 'Поясной барабан Вдохновения',
    willowbend_fan: 'Веер Ивового изгиба',
  },
  roles: {
    weapon: {
      [WeaponRole.Tank]: 'Танк',
      [WeaponRole.Dps]: 'Урон',
      [WeaponRole.Heal]: 'Лекарь',
    },
    player: {
      [PlayerRole.Tank]: 'Танк',
      [PlayerRole.Dps]: 'Урон',
      [PlayerRole.Hybrid]: 'Гибрид',
      [PlayerRole.Heal]: 'Лекарь',
    },
    total: 'Всего',
  },
  picker: {
    chooseWeapon: 'Выберите оружие',
    noWeaponsAvailable: 'Нет доступного оружия',
    selectWeapon: (weaponName: string, roleLabel: string) => `Выбрать ${weaponName} (${roleLabel})`,
    unavailableSuffix: ' — недоступно, уже выбрано в другом слоте',
    weaponTitle: (weaponName: string, roleLabel: string) => `${weaponName} · ${roleLabel}`,
  },
  controller: {
    chooseFirstBuildWeapon: 'Выберите первое оружие сборки',
    chooseSecondBuildWeapon: 'Выберите второе оружие сборки',
    chooseFirstGuildBuildWeapon: 'Выберите первое оружие гильдейской сборки',
    chooseSecondGuildBuildWeapon: 'Выберите второе оружие гильдейской сборки',
    addAltWeapon: 'Добавить дополнительное оружие',
  },
  slot: {
    chooseBuild: 'Выберите сборку',
    chooseSavedBuild: 'Выберите сохранённую сборку',
  },
  builds: {
    chooserHint: 'Выберите личную или гильдейскую экипировку',
    savedBuilds: 'Сохранённые сборки',
    playerBuilds: 'Личные сборки',
    guildBuilds: 'Гильдейские сборки',
    buildLabel: (number: number) => `Сборка ${String(number)}`,
    guildBuildLabel: (number: number) => `Гильдейская сборка ${String(number)}`,
    defaultLabel: 'По умолчанию',
    activeLabel: 'Активна',
    requiresDistinctWeapons: 'Нужны 2 разных оружия',
    noWeaponsSelected: 'Оружие не выбрано',
    activeBuildTitle: (summary: string) => `Активная сборка — ${summary}`,
    useBuildTitle: (number: number, summary: string) => `Использовать сборку ${String(number)} — ${summary}`,
    unavailableBuildTitle: (number: number, summary: string) => `Сохранённая сборка ${String(number)} — недоступна: нужны два разных оружия — ${summary}`,
    savedBuildTitle: (number: number, summary: string) => `Сохранённая сборка ${String(number)} — ${summary}`,
    useGuildBuildTitle: (summary: string) => `Использовать гильдейскую сборку — ${summary}`,
    makeDefault: 'Сделать основной',
    noSavedBuilds: 'Сохранённых сборок пока нет.',
    createBuild: '+ Создать сборку',
    liveBuildAuthorization: 'Выбирать активную сборку может только этот игрок или офицер гильдии.',
    hideAvailableBuilds: 'Скрыть доступные сборки',
    assignMoreBuilds: 'Назначить ещё сборки',
    availableToAssign: 'Доступны для назначения',
    noAssignedGuildBuilds: 'Этому игроку пока не назначены гильдейские сборки.',
    noGuildBuilds: 'Для этого игрока пока нет гильдейских сборок.',
    saveCurrentLoadoutAsPersonalBuild: '+ Сохранить как личную сборку',
    saveCurrentLoadout: '+ Сохранить текущую экипировку',
    createGuildBuild: '+ Создать гильдейскую сборку',
    notAssigned: 'Не назначена',
    assignToPlayer: 'Назначить игроку',
    editFirst: 'Изменить первое',
    editSecond: 'Изменить второе',
    remove: 'Удалить',
  },
  stats: {
    triggerLabel: (roomName: string) => `Статистика оружия: ${roomName}`,
    dialogLabel: 'Статистика оружия в этой комнате',
    closeLabel: 'Закрыть статистику оружия',
    players: 'игроков',
    unlimited: 'Без ограничений',
    loadout: 'Экипировка оружием',
    totalCount: (count: number) => `Всего: ${String(count)}`,
    noWeaponsAssigned: 'Оружие не назначено',
  },
}
